import { Link } from "@/components/common/Link";
export default function ProductHeroSection() {
  return;
}